<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <dashboard-gerencial
          :loading="loading"
          :execucao="execucao"
          @download-arquivo-comparativo="baixarArquivoComparativo"
          @download-arquivo-ajuste-manual="baixarArquivoAjusteManual"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import SaneamentosRazaoService from '@/services/SaneamentosRazaoService';

  export default {
    name: 'PainelGerencialSaneamentoRazao',

    components: {
      DashboardGerencial: () => import('@/components/saneamentoRazao/DashboardGerencial.vue')
    },

    data() {
      return {
        loading: true,
        execucao: null
      };
    },

    created() {
      this.getDados();
    },

    methods: {
      getDados() {
        this.loading = true;
        SaneamentosRazaoService.getDadosPainel(this.$route.params.id)
          .then((response) => {
            this.execucao = response.data.data;
          })
          .catch((error) => {
            console.error(error);
            this.$toast.error('Erro ao carregar dados do painel gerencial.', '', {
              position: 'topRight'
            });
          })
          .finally(() => {
            this.loading = false;
          });
      },
      baixarArquivoComparativo() {
        this.$toast.info('Preparando o arquivo logs (comparativo) para download...', '', {
          position: 'topRight'
        });

        SaneamentosRazaoService.baixarArquivoComparativo(this.$route.params.id)
          .then((res) => {
            const nomeArquivo = `logs_comparativo_saneamento_razao_${this.$route.params.id}.zip`;
            const url = window.URL.createObjectURL(new Blob([res.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', nomeArquivo);
            document.body.appendChild(link);
            link.click();
          })
          .catch((error) => {
            console.error(error);
            this.$toast.error('Erro ao baixar arquivo comparativo.', '', {
              position: 'topRight'
            });
          });
      },

      baixarArquivoAjusteManual() {
        this.$toast.info('Preparando o arquivo de ajuste manual para download...', '', {
          position: 'topRight'
        });

        SaneamentosRazaoService.baixarArquivoAjusteManual(this.$route.params.id)
          .then((res) => {
            const nomeArquivo = `ajuste_manual_saneamento_razao_${this.$route.params.id}.zip`;
            const url = window.URL.createObjectURL(new Blob([res.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', nomeArquivo);
            document.body.appendChild(link);
            link.click();
          })
          .catch((error) => {
            console.error(error);
            this.$toast.error('Erro ao baixar arquivo de ajuste manual.', '', {
              position: 'topRight'
            });
          });
      }
    }
  };
</script>
